import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { toastActions } from 'redux/toasts';
import { useTranslation } from 'react-i18next';
import { Toast } from 'models/toasts';
import iconComplete from 'assets/images/icon_complete.svg';
import { completionToastDisplayTime } from 'constants/toasts';
type PropsType = {
  toast: Toast;
};

const InfoToast: React.FunctionComponent<PropsType> = ({ toast }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('toast');

  useEffect(() => {
    const { toast_id, content } = toast;
    const { displayTime } = content;
    setTimeout(
      () => {
        displayTime !== Infinity &&
          dispatch(toastActions.removeToast(toast_id));
      },
      displayTime ? displayTime : completionToastDisplayTime
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <InfoToastHeaderTitle>
        <IconComplete />
        <Strong className="mr-auto">
          {toast.content.title ? toast.content.title : t('completion')}
        </Strong>
      </InfoToastHeaderTitle>
      <InfoToastBody className="toast-body">
        {toast.content.message}
      </InfoToastBody>
    </React.Fragment>
  );
};
const Strong = styled.strong`
  color: #ffffff;
`;
const InfoToastBody = styled.div`
  color: rgba(54, 114, 82);
  white-space: pre-line;
`;
const InfoToastHeaderTitle = styled.div`
  display: flex;
  align-items: center;
  height: 37px;
  padding: 0.25rem 0.75rem;
  color: #ffffff;
  background-color: rgba(118, 196, 33, 0.68);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;
const IconComplete = styled.div`
  display: flex;
  width: 18px;
  height: 13px;
  margin-right: 8px;
  background-image: url(${iconComplete});
`;

export default InfoToast;
